module.exports = __webpack_public_path__ + "static/media/markerFilter2.f2426113.svg";